module.exports = __webpack_public_path__ + "h5/img/home_f1.963f17ab.png";